import {useEffect} from 'react';

import {usePersonality} from '../../provider/personality/use-personality';
import {SelectorBrandType} from '../../service/feature-companies/feature-companies-type';

export function useBigBrandForceBrandSelect(
    brands: Array<SelectorBrandType> | undefined,
    brandChangeFunction: (brandId: number) => void
): void {
    const {isBigBrand} = usePersonality();

    useEffect(() => {
        if (brands && isBigBrand && brands[0]) {
            brandChangeFunction(brands[0].id);
        }
    }, [brandChangeFunction, brands, isBigBrand]);
}
